var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBackpack = function SvgIconBackpack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.375a1 1 0 0 0 0 2h3.75a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 3.375v1.286a5.5 5.5 0 0 0-4.875 5.464v10.5a1.75 1.75 0 0 0 1.75 1.75h14.25a1.75 1.75 0 0 0 1.75-1.75v-10.5A5.5 5.5 0 0 0 16 4.661V3.375a2.5 2.5 0 0 0-2.5-2.5h-3a2.5 2.5 0 0 0-2.5 2.5m2.5-.5a.5.5 0 0 0-.5.5v1.25h4v-1.25a.5.5 0 0 0-.5-.5zm4.875 3.75h-6.75a3.5 3.5 0 0 0-3.5 3.5v10.25h1.75V14.25a2.5 2.5 0 0 1 2.5-2.5h5.25a2.5 2.5 0 0 1 2.5 2.5v6.125h1.75v-10.25a3.5 3.5 0 0 0-3.5-3.5m-6.5 13.75v-3.25h3.25v.5a1 1 0 1 0 2 0v-.5h1v3.25zm6.25-5.25v-.875a.5.5 0 0 0-.5-.5h-5.25a.5.5 0 0 0-.5.5v.875z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBackpack;